import { Component, Inject, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Cliente } from 'src/app/models/cliente.model';
import { ComposicaoEquipe } from 'src/app/models/composicao-equipe.model';
import { EstimativaColaborador } from 'src/app/models/estimativa-gerenciar-colaborador';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { Misc } from '../../util/misc';
import { ToastrComponent } from '../../util/toastr/toastr.component';
import { Equipe } from 'src/app/models/equipe.model';

@Component({
  selector: 'app-estimativa-gerenciar-colaborador',
  templateUrl: './estimativa-gerenciar-colaborador.component.html',
  styleUrls: ['./estimativa-gerenciar-colaborador.component.scss']
})
export class EstimativaGerenciarColaboradorComponent implements OnInit {

  displayedColumns: string[] = ['colaborador', 'quantidade', 'valor'];
  displayedColumns2: string[] = ['quantidadeEditar', 'valorEditar'];
  loading: boolean;
  modalRef: BsModalRef;
  colaboradorSelecionado: string;
  cpfColaboradorSelecionado: any;
  quantidadeHoraEditar: number;
  valorHoraEditar: number;
  quantidadeHoraModal: any;
  valorHoraModal: any;
  CpfSelecionado: number;
  quantidadeHora: number;
  valorHora: number;
  filteredOptions: any = [];
  nomeCompleto: any;
  tableData: any;
  colaboradorId: number;
  equipeId: number;
  basicForm: UntypedFormGroup;
  basicFormEditar: UntypedFormGroup;
  liberarSalvar: boolean = false;
  equipe: Equipe;

  constructor(
    public dialogRef: MatDialogRef<ComposicaoEquipe>,
    private fb: UntypedFormBuilder,
    private fbEditar: UntypedFormBuilder,
    private modalService: BsModalService,
    private toastr: ToastrComponent,
    public misc: Misc,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private estimativaService: EstimativaService) {
    this.createForm();
    this.createFormEditar();
  }

  ngOnInit() {
    this.getEquipeId();
  }

  colaboradorSelect(colaborador: any) {
    this.colaboradorSelecionado = colaborador.nomeColaborador;
    this.cpfColaboradorSelecionado = colaborador.cpfColaborador;
    this.colaboradorId = colaborador.id;
    this.quantidadeHoraModal = colaborador.qtdeHora;
    this.valorHoraModal = colaborador.valorHora;
    // this.createFormEditar();

    this.basicFormEditar.controls['valorEditar'].setValue(this.valorHoraModal);
    this.basicFormEditar.controls['quantidadeEditar'].setValue(this.quantidadeHoraModal);
  }


  createForm() {
    this.basicForm = this.fb.group({
      colaborador: [null, [Validators.required]],
      quantidade: [null, [Validators.required]],
      valor: [null, [Validators.required]]
    });
  }

  createFormEditar() {
    this.basicFormEditar = this.fbEditar.group({
      quantidadeEditar: ['', [Validators.required]],
      valorEditar: ['', [Validators.required]]
    });
  }

  getCPF(cpf, nome) {
    this.CpfSelecionado = cpf;
    this.nomeCompleto = nome;

    this.liberarSalvarColaborador();

  }

  apagar() {

    this.liberarSalvar = false;
    this.CpfSelecionado = 1;
  }

  liberarSalvarColaborador() {

    if (this.basicForm.controls['valor'].value == undefined || this.basicForm.controls['valor'].value == "" || this.basicForm.controls['quantidade'].value == undefined || this.basicForm.controls['quantidade'].value == "") {
      {
        this.liberarSalvar = false;
      }

    } else {

      if (this.CpfSelecionado != 1 && this.nomeCompleto != undefined)
        this.liberarSalvar = true;
    }
  }

  getColaborador(value: any) {
    var colaborador: any = [];

    if (value.target.value.length >= 3) {
      this.estimativaService.getColaboradorLista(value.target.value).subscribe((result: any) => {
        colaborador.push(result.colaboradores);
      })
      this.filteredOptions = colaborador;
    }
  }

  getEquipeId() {
    this.estimativaService.getEquipeId(this.data.estimativaId).subscribe((result: any) => {

      this.equipeId = result.items[0].composicaoEquipe.equipeId;
      this.equipe = result.items[0];
      this.estimativaService.getEquipe(this.equipeId).subscribe((result: any) => {

        this.tableData = result

        this.loading = false;

      })

    })
  }

  enterSave() {
    if (!this.basicForm.valid) {
      return;
    }

    this.save();
    this.getEquipeId();
  }


  save() {
    const dados = {
      EquipeId: this.equipeId,
      Equipe: this.equipe,
      CpfColaborador: this.CpfSelecionado,
      NomeColaboradorContratar: this.nomeCompleto,
      ValorHora: this.valorHora,
      QtdeHora: this.quantidadeHora
    } as EstimativaColaborador;


    if (this.valorHora <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', 'Valor Hora não pode ser igual ou menor que zero');
      this.loading = true;
    }
    else if (this.quantidadeHora <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', 'Quantidade Hora não pode ser igual ou menor que zero');
      this.loading = true;
    }
    else {
      this.estimativaService.gravarComposicaoEquipe(dados).subscribe(result => {
        this.basicForm.reset();
      });

      this.loading = true;
      this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Colaborador adicionado com sucesso');
      this.close();
    }

  }

  enterSaveEditar() {
    if (!this.basicFormEditar.valid) {
      return;
    }

    this.saveEditar();
    this.getEquipeId();
  }

  saveEditar() {
    const dados = {
      id: this.data.estimativaId,
      EquipeId: this.equipeId,
      CpfColaborador: this.cpfColaboradorSelecionado,
      ValorHora: this.basicFormEditar.controls['valorEditar'].value,
      QtdeHora: this.basicFormEditar.controls['quantidadeEditar'].value
    } as EstimativaColaborador;

    this.estimativaService.updateC(dados).subscribe();

    this.loading = true;
    this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Horas alteradas com sucesso');

    this.quantidadeHoraEditar = null;
    this.valorHoraEditar = null;

  }

  deleteEquipe() {
    this.estimativaService.deleteEquipe(this.colaboradorId).subscribe();

    this.loading = true;
    this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Colaborador excluído com sucesso');

    this.getEquipeId();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  close(): void {
    this.dialogRef.close();
  }

  displayFn(colaborador: any): string {
    return colaborador && colaborador.nomeCompleto ? colaborador.nomeCompleto : '';
  }
}

